import { render, staticRenderFns } from "./blueprint-channels.vue?vue&type=template&id=010bbc3c&scoped=true&"
import script from "./blueprint-channels.vue?vue&type=script&lang=ts&"
export * from "./blueprint-channels.vue?vue&type=script&lang=ts&"
import style0 from "./blueprint-channels.vue?vue&type=style&index=0&id=010bbc3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010bbc3c",
  null
  
)

export default component.exports